<template>
	<b-navbar toggleable="lg" type="dark" variant="dark">
		<b-container>
			<b-navbar-brand href="#">Money Guided Admin</b-navbar-brand>
			<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
			<b-collapse id="nav-collapse" is-nav>
				<!-- Right aligned nav items -->
				<b-navbar-nav class="ml-auto" right>
					<router-link class="w-link" to="/home">Home</router-link>
					<router-link class="w-link" to="/cms">CMS</router-link>
					<router-link class="w-link" to="/cdn">CDN</router-link>
					<router-link class="w-link" to="/psms">PSMs</router-link>
					<router-link class="w-link" to="/achievements">Achievements</router-link>
					<router-link class="w-link" to="/questions">Questions</router-link>
					<router-link class="w-link" to="/wellbeing">Wellbeing</router-link>
					<router-link class="w-link" to="/stats">Stats</router-link>
					<router-link class="w-link" to="/lists">Lists</router-link>
					<router-link class="w-link" to="/classifications">Transaction Classifications</router-link>
				</b-navbar-nav>
			</b-collapse>
		</b-container>
	</b-navbar>
</template>

<script>
export default {
 props: {
   menuMode: String
 },
 methods: {
   menuEvent(mode) {
		this.menuMode = mode;
		this.$emit('menuEvent', mode);
   }
 }
}
</script>

<style>
	.ml-auto {
		margin-left:auto;
	}
	.w-link, .w-link:hover, .w-link:active {
		color: white;
		text-decoration: none;
	}
</style>